/* Wondr Light - product gallery behaviour. Vanilla JS. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function setup(gallery) {
    if (gallery.getAttribute('data-wonder-gal-ready') === 'true') return;
    gallery.setAttribute('data-wonder-gal-ready', 'true');

    var track = gallery.querySelector('[data-wonder-gal-track]');
    var slides = gallery.querySelectorAll('[data-wonder-gal-slide]');
    var thumbs = gallery.querySelectorAll('[data-wonder-gal-thumb]');
    var prev = gallery.querySelector('[data-wonder-gal-prev]');
    var next = gallery.querySelector('[data-wonder-gal-next]');
    var count = gallery.querySelector('[data-wonder-gal-count]');
    if (!track || slides.length < 2) return;

    var current = 0;

    function goTo(index, instant) {
      index = Math.max(0, Math.min(slides.length - 1, index));
      track.scrollTo({
        left: index * track.clientWidth,
        behavior: instant || reduceMotion.matches ? 'auto' : 'smooth'
      });
    }

    function keepThumbVisible(thumb) {
      var list = thumb.parentNode.parentNode;
      if (!list) return;
      if (list.scrollHeight > list.clientHeight + 1) {
        list.scrollTop = thumb.offsetTop - (list.clientHeight - thumb.offsetHeight) / 2;
      } else if (list.scrollWidth > list.clientWidth + 1) {
        list.scrollLeft = thumb.offsetLeft - (list.clientWidth - thumb.offsetWidth) / 2;
      }
    }

    function update() {
      var index = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
      index = Math.max(0, Math.min(slides.length - 1, index));
      if (index === current && track.getAttribute('data-wonder-gal-init')) return;
      track.setAttribute('data-wonder-gal-init', 'true');
      current = index;

      thumbs.forEach(function (thumb, i) {
        thumb.setAttribute('aria-current', i === index ? 'true' : 'false');
        if (i === index) keepThumbVisible(thumb);
      });
      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index === slides.length - 1;
      if (count) count.textContent = index + 1 + ' / ' + slides.length;
    }

    var frame = null;
    track.addEventListener(
      'scroll',
      function () {
        if (frame) return;
        frame = window.requestAnimationFrame(function () {
          frame = null;
          update();
        });
      },
      { passive: true }
    );

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        goTo(i);
      });
    });
    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });

    track.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        goTo(current - 1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        goTo(current + 1);
      }
    });

    window.addEventListener('resize', function () {
      goTo(current, true);
    });

    update();
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-wonder-gal]').forEach(setup);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }
})();